module.exports = __webpack_public_path__ + "media/images/items/static-6-63d4ba6fbbe0a170b45e8dd44af41938.jpg";